import {GetDefaultIndex} from '../../components';
import { useGetActivityGroupsCommonInfoQuery } from "../../features/api/apiSlice";
import {useActivityGroupRoutes} from './routes';

export {useActivityGroupRoutes};

export default GetDefaultIndex({title: 'گروه های فعالیت', query: useGetActivityGroupsCommonInfoQuery});
